import { Suspense } from 'react';

import { lazyRetry } from '@cast/utils';

import { SuspenseLoader } from 'components/loaders';
import { useAbility } from '@cast/shared-ability-data-access';

const SplitMeDbOptimizationController = lazyRetry(
  () => import('@cast/split-me/pages/db-optimization/DbOptimizationController')
);
const SplitMeDbOptimizationControllerV2 = lazyRetry(
  () =>
    import(
      'pages/db-optimization/v2/DbOptimizationControllerV2/DbOptimizationControllerV2'
    )
);

export const DbOptimizationController = () => {
  const isDboV2Enabled = useAbility().can('view', 'FeatureDboV2');
  return (
    <Suspense fallback={<SuspenseLoader />}>
      {isDboV2Enabled ? (
        <SplitMeDbOptimizationControllerV2 />
      ) : (
        <SplitMeDbOptimizationController />
      )}
    </Suspense>
  );
};
